import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostureComponent } from './posture.component';

const routes: Routes = [{ path: '', component: PostureComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostureRoutingModule {}
